module.exports = __webpack_public_path__ + "img/why-icon-2.f35d8fd7.svg";